import appConstants from "../../../../appConstants";
import { MultiSelectFilter, DateTimeFilter } from '@dataGrid/components/columnFilters';
import { formatAddress } from "../../Dispatch/utils/utils";

export default class GridConfig {
  constructor(configuration) {
    const config = configuration || {};
    this.name = "GridConfiguration";
    this.config = GridConfig.getConfiguration(config);
  }
  static getConfiguration(config) {
    return GridConfig.getDefaultConfiguration(config.featureFlags);
  }

  static getCustomerAddress = (params) => {
    return formatAddress({address:params.data.address, address2: params.data.address2});
  }

  static getDefaultConfiguration(featureFlags = {}) {
    const { isDuplicateCustomerTerminalLevelEnabled = false } = featureFlags;

    const defaultConfig = {
      title: appConstants.gridNames.DuplicateCustomerGrid,
      keyColumn: "customerID",
      rowSelection: "multiple",
      rowDeselection: true,
      columns: [
        {
          headerName: "Route",
          field: "route",
          cellClass: "gridCell-leftAlign",
          filter: MultiSelectFilter,
          minWidth: appConstants.columnWidth.DUPLICATE_CUSTOMERS_ROUTE,
        },
        {
          headerName: "Customer ID",
          field: "customerCode",
          cellClass: "gridCell-leftAlign",
          filter: MultiSelectFilter,
          minWidth: appConstants.columnWidth.DUPLICATE_CUSTOMERS_CUSTOMER,
        },
        {
          headerName: "Customer",
          field: "customer",
          cellClass: "gridCell-leftAlign",
          filter: MultiSelectFilter,
          minWidth: appConstants.columnWidth.DUPLICATE_CUSTOMERS_CUSTOMER,
          filterParams:{
            width: appConstants.columnWidth.W_300
          }
        },
        {
          headerName: "Address",
          field: "address",
          tooltipValueGetter: (params) => params.value,
          valueGetter : GridConfig.getCustomerAddress,
          cellClass: "gridCell-leftAlign",
          filter: MultiSelectFilter,
          minWidth: appConstants.columnWidth.DUPLICATE_CUSTOMERS_ADDRESS,
          filterParams:{
            width: appConstants.columnWidth.W_300
          }
        },
        {
          headerName: "Sanitized Address",
          field: "sanitizedAddress",
          tooltipValueGetter: (params) => params.value,
          cellClass: "gridCell-leftAlign",
          filter: MultiSelectFilter,
          minWidth: appConstants.columnWidth.DUPLICATE_CUSTOMERS_ADDRESS,
          filterParams:{
            width: appConstants.columnWidth.W_300
          }
        },
        {
          headerName: "City",
          field: "city",
          cellClass: "gridCell-leftAlign",
          filter: MultiSelectFilter,
          minWidth: appConstants.columnWidth.DUPLICATE_CUSTOMERS_CITY,
        },
        {
          headerName: "State",
          field: "state",
          cellClass: "gridCell-leftAlign",
          filter: MultiSelectFilter,
          minWidth: appConstants.columnWidth.DUPLICATE_CUSTOMERS_CITY,
        },
        {
          headerName: "Zip",
          field: "zip",
          cellClass: "gridCell-leftAlign",
          filter: MultiSelectFilter,
          minWidth: appConstants.columnWidth.DUPLICATE_CUSTOMERS_CITY,
        },
        {
          headerName: "Delivery Window",
          field: "deliveryWindow",
          cellClass: "gridCell-leftAlign",
          filter: DateTimeFilter,
          filterParams: {
            DATETYPE: appConstants.DATETYPES.TIME,
            isTimeInterval: true,
          },
          minWidth:
            appConstants.columnWidth.DUPLICATE_CUSTOMERS_DELIVERY_WINDOW,
        },
      ],
    };

    defaultConfig.columns = defaultConfig.columns.filter((column) => {
      switch (column.field) {
        case "route":
        case "deliveryWindow":
          return !isDuplicateCustomerTerminalLevelEnabled;
        default:
          return true;
      }
    });

    return defaultConfig;
  }
}
